"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HUD = void 0;
var GameVars_1 = require("../../../GameVars");
var GemsContainer_1 = require("./GemsContainer");
var Badges_1 = require("./Badges");
var HUD = /** @class */ (function (_super) {
    __extends(HUD, _super);
    function HUD(scene) {
        var _this = _super.call(this, scene) || this;
        _this.x = GameVars_1.GameVars.gameWidth / 2;
        var coinsContainer = new Phaser.GameObjects.Container(_this.scene);
        coinsContainer.y = 40 * GameVars_1.GameVars.scaleY;
        coinsContainer.scaleY = GameVars_1.GameVars.scaleY;
        _this.add(coinsContainer);
        var capsulesBackground = new Phaser.GameObjects.Image(_this.scene, -120, 0, "texture_atlas_1", "info_gold");
        coinsContainer.add(capsulesBackground);
        capsulesBackground = new Phaser.GameObjects.Image(_this.scene, 122, 0, "texture_atlas_1", "info_gold");
        coinsContainer.add(capsulesBackground);
        _this.coinsLabel = new Phaser.GameObjects.Text(_this.scene, -140, -2, "", { fontFamily: "Baloo", fontSize: "30px", color: "#E963BC" });
        _this.coinsLabel.setOrigin(0, .5);
        coinsContainer.add(_this.coinsLabel);
        _this.coinsIcon = new Phaser.GameObjects.Image(_this.scene, -200, 0, "texture_atlas_1", "info_gold_icon");
        coinsContainer.add(_this.coinsIcon);
        _this.coinsPerSecondLabel = new Phaser.GameObjects.Text(_this.scene, 80, -2, "", { fontFamily: "Baloo", fontSize: "30px", color: "#E963BC" });
        _this.coinsPerSecondLabel.setOrigin(0, .5);
        coinsContainer.add(_this.coinsPerSecondLabel);
        _this.coinsPerSecondIcon = new Phaser.GameObjects.Image(_this.scene, 30, 0, "texture_atlas_1", "info_gold_time_icon");
        coinsContainer.add(_this.coinsPerSecondIcon);
        _this.gemsContainer = new GemsContainer_1.GemsContainer(_this.scene);
        _this.add(_this.gemsContainer);
        var badges = new Badges_1.Badges(_this.scene);
        _this.add(badges);
        _this.updateCoinsCounters();
        return _this;
    }
    HUD.prototype.updateCoinsCounters = function () {
        this.coinsLabel.text = GameVars_1.GameVars.formatNumber(Math.round(GameVars_1.GameVars.modeGameData.coins));
        this.coinsPerSecondLabel.text = GameVars_1.GameVars.formatNumber(GameVars_1.GameVars.coinsPerSecond) + "/" + GameVars_1.GameVars.gameText[GameVars_1.GameVars.language].SECONDS;
        if (this.coinsPerSecondLabel.text.length > 9) {
            this.coinsPerSecondLabel.setFontSize(28);
        }
        else {
            this.coinsPerSecondLabel.setFontSize(30);
        }
    };
    HUD.prototype.updateStarsContainer = function () {
        this.gemsContainer.updateGems();
    };
    return HUD;
}(Phaser.GameObjects.Container));
exports.HUD = HUD;
